import { render } from "./index.vue?vue&type=template&id=1209fe25&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1209fe25&scoped=true&lang=css"

import exportComponent from "E:\\pay\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1209fe25"]])

export default __exports__